import { Card } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const ChartsCard = styled(Card)`
  background: ${({ theme }) => theme.settings.whiteColor};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.settings.borderColor};
  box-shadow:
    0px 6px 29px rgba(89, 108, 148, 0.07),
    0px 0.751293px 3.63125px rgba(89, 108, 148, 0.035);
  height: 100%;
  min-height: 280px;
  .ant-card-head {
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px !important;
    font-weight: 500 !important;
    line-height: 24px !important;
    color: ${({ theme }) => theme.settings.tertiary};
    border-bottom: none;
    padding-top: 10px;
    min-height: 40px;
  }
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    transform: translateY(-4px) scale(1.02);
    box-shadow:
      0px 12px 40px rgba(89, 108, 148, 0.15),
      0px 4px 12px rgba(89, 108, 148, 0.08),
      0px 0px 0px 1px rgba(89, 108, 148, 0.1);
  }
  .ant-card-body {
    padding: 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  &.barGraphCard,
  &.stackBarChartCard {
    .ant-card-head {
      padding-top: 6px;
      padding-bottom: 0;
      min-height: 32px;
    }
    .ant-card-body {
      padding: 8px 12px 12px;
    }
  }
`;
